var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',{attrs:{"active":_vm.active,"align-center":""}},_vm._l((_vm.steps),function(step,step_idx){return _c('el-step',{key:step,class:[step_idx < _vm.active ? 'is-finish' : 'not-finish'],attrs:{"title":step}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }